import { render } from "./KnowledgeBase.vue?vue&type=template&id=4871f735&ts=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBase.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__